import React from "react";
import {Tribe} from "../../enum/Tribe";
import './ImageUnit.sass';

type Props = {
    size?: 16|26,
    tribe: Tribe,
    troopId: 1|2|3|4|5|6|7|8|9|10,
    grayscale?: boolean,
}

export default function ImageUnit({ size, tribe, troopId, grayscale }: Props) {
    return <i className={`travianUnitImage size-${size ?? 16} tribe-${tribe} troopId-${troopId} ${grayscale ? 'filter-grayscale' : ''}`}></i>
}
